






























import PhotoUploader from "@/components/PhotoUploader.vue";
import { Component, Vue } from "vue-property-decorator";
import ProjectMemberOne from "./ProjectMemberOne.vue";
import VMessageControl from "@/components/VMessageControl.vue";
import MessageOutput from "@/models/message-output";
import UploadFileProject from "@/models/specs/UploadFileProject";

@Component({
  components: {
    PhotoUploader,
    ProjectMemberOne,
    "v-message-control": VMessageControl
  }
})
export default class MessageEditor extends Vue {
  uploaderVisible: Boolean = false;
  message = new MessageOutput();
  file: File | null = null;

  submit() {
    this.sendMessage(this.message);
    this.message = new MessageOutput();
  }

  sendMessage(message: MessageOutput) {
    const data = new FormData();
    data.append("projectId", this.$store.state.projectId);
    data.append("body", message.body);
    message.to.forEach((id, i) => {
      // toに無が入っていることがある
      if (!message.to[i]) return;
      data.append(`to[${i}]`, id);
    });
    if (this.file) {
      const spec = new UploadFileProject();
      if (!spec.isSatisfied(this.file)) {
        alert(spec.errors);
        return;
      }
      data.append("image", this.file);
    }
    this.$emit("submit", data);
  }

  showUploader(files: FileList) {
    if (!files.length) return;
    this.file = files[0];
    this.uploaderVisible = true;
  }

  hideUploader() {
    this.file = null;
    this.uploaderVisible = false;
  }
}
